module.exports = __webpack_public_path__ + "img/missionaries30_2019_7-7-2021.7c36009e.jpg";